import Entity from './Entity.js'

class Player extends Entity {
    
    constructor(id) {
        super();
        this.id = id;
        this.width = 20;
        this.height = 20;
    }
    
    getId() {
        return this.id
    }
    
    tick() {
        super.tick()
    }
    
    draw(ctx) {
        super.draw(ctx)
        const position = this.getPosition();
        const size = this.getSize();
        ctx.fillRect(position.getX(), position.getY(), size.getWidth(), size.getHeight());
    }
    
}

export default Player
